export enum FileExtension {
  Pdf = 'pdf',
  Png = 'png',
  Jpg = 'jpg',
  Jpeg = 'jpeg',
}

export enum ExtensionCategory {
  Image = 'image',
  Pdf = 'pdf',
  Unsupported = 'unsupported',
}

export const supportedPreviewExtensions = [
  FileExtension.Pdf,
  FileExtension.Png,
  FileExtension.Jpg,
  FileExtension.Jpeg,
];

export const imageExtensions = [
  FileExtension.Png,
  FileExtension.Jpg,
  FileExtension.Jpeg,
];
